export const levels = [
    {
        settings: { symType: 'Vertical' },
        collections: [
            {
                items: [
                    { xpos: 1, ypos: 2, color: '#eeaf61' },
                    { xpos: 2, ypos: 2, color: '#eeaf61' },
                    { xpos: 3, ypos: 2, color: '#eeaf61' },
                    { xpos: 3, ypos: 1, color: '#eeaf61' },
                    { xpos: 1, ypos: 3, color: '#eeaf61' },
                    { xpos: 2, ypos: 3, color: '#eeaf61' }
                ],
                selected: false,
                type: 'ACTIVE'
            },
            {
                items: [
                    { xpos: 5, ypos: 4, color: '#eeaf61' },
                    { xpos: 5, ypos: 5, color: '#eeaf61' }
                ],
                selected: true,
                type: 'ACTIVE'
            },
            {
                items: [
                    { xpos: 0, ypos: 1, color: '#454545' },
                    { xpos: 1, ypos: 1, color: '#eeaf61' }
                ],
                selected: false,
                type: 'PASSIVE'
            },
            {
                items: [
                    { xpos: 0, ypos: 5, color: '#454545' },
                    { xpos: 1, ypos: 5, color: '#454545' },
                    { xpos: 1, ypos: 6, color: '#454545' },
                    { xpos: 3, ypos: 6, color: '#454545' },
                    { xpos: 4, ypos: 6, color: '#454545' },
                    { xpos: 4, ypos: 5, color: '#454545' }
                ],
                selected: false,
                type: 'PASSIVE'
            }
        ]
    },
    {
        settings: { symType: 'Vertical' },
        collections: [
            {
                items: [
                    { xpos: 1, ypos: 1, color: '#eeaf61' },
                    { xpos: 2, ypos: 1, color: '#eeaf61' },
                    { xpos: 0, ypos: 2, color: '#eeaf61' },
                    { xpos: 1, ypos: 2, color: '#eeaf61' }
                ],
                selected: true,
                type: 'ACTIVE'
            },
            {
                items: [
                    { xpos: 4, ypos: 6, color: '#eeaf61' },
                    { xpos: 5, ypos: 6, color: '#eeaf61' },
                    { xpos: 3, ypos: 7, color: '#eeaf61' },
                    { xpos: 4, ypos: 7, color: '#eeaf61' }
                ],
                selected: false,
                type: 'ACTIVE'
            },
            {
                items: [
                    { xpos: 0, ypos: 3, color: '#454545' },
                    { xpos: 0, ypos: 4, color: '#eeaf61' }
                ],
                selected: false,
                type: 'PASSIVE'
            },
            {
                items: [
                    { xpos: 5, ypos: 4, color: '#454545' },
                    { xpos: 4, ypos: 5, color: '#454545' },
                    { xpos: 5, ypos: 5, color: '#454545' }
                ],
                selected: false,
                type: 'PASSIVE'
            },
            {
                items: [{ xpos: 3, ypos: 1, color: '#454545' }],
                selected: false,
                type: 'PASSIVE'
            },
            {
                items: [{ xpos: 2, ypos: 7, color: '#454545' }],
                selected: false,
                type: 'PASSIVE'
            }
        ]
    },
    {
        settings: { symType: 'Vertical' },
        collections: [
            {
                items: [
                    { xpos: 4, ypos: 1, color: '#eeaf61' },
                    { xpos: 5, ypos: 1, color: '#eeaf61' },
                    { xpos: 4, ypos: 2, color: '#eeaf61' },
                    { xpos: 3, ypos: 3, color: '#eeaf61' },
                    { xpos: 4, ypos: 3, color: '#eeaf61' }
                ],
                selected: true,
                type: 'ACTIVE'
            },
            {
                items: [
                    { xpos: 1, ypos: 6, color: '#eeaf61' },
                    { xpos: 1, ypos: 7, color: '#eeaf61' },
                    { xpos: 2, ypos: 7, color: '#eeaf61' }
                ],
                selected: false,
                type: 'ACTIVE'
            },
            {
                items: [
                    { xpos: 0, ypos: 1, color: '#454545' },
                    { xpos: 1, ypos: 1, color: '#eeaf61' },
                    { xpos: 1, ypos: 2, color: '#eeaf61' },
                    { xpos: 2, ypos: 1, color: '#eeaf61' },
                    { xpos: 1, ypos: 3, color: '#eeaf61' }
                ],
                selected: false,
                type: 'PASSIVE'
            },
            {
                items: [
                    { xpos: 3, ypos: 5, color: '#454545' },
                    { xpos: 4, ypos: 5, color: '#454545' },
                    { xpos: 3, ypos: 6, color: '#454545' },
                    { xpos: 3, ypos: 7, color: '#454545' }
                ],
                selected: false,
                type: 'PASSIVE'
            }
        ]
    },
    {
        settings: { symType: 'Horizontal' },
        collections: [
            {
                items: [
                    { xpos: 1, ypos: 1, color: '#eeaf61' },
                    { xpos: 1, ypos: 2, color: '#eeaf61' },
                    { xpos: 2, ypos: 2, color: '#eeaf61' }
                ],
                selected: true,
                type: 'ACTIVE'
            },
            {
                items: [
                    { xpos: 0, ypos: 7, color: '#eeaf61' },
                    { xpos: 1, ypos: 6, color: '#eeaf61' },
                    { xpos: 1, ypos: 7, color: '#eeaf61' },
                    { xpos: 1, ypos: 8, color: '#eeaf61' }
                ],
                selected: false,
                type: 'ACTIVE'
            },
            {
                items: [{ xpos: 4, ypos: 7, color: '#eeaf61' }],
                selected: false,
                type: 'ACTIVE'
            },
            {
                items: [{ xpos: 4, ypos: 4, color: '#454545' }],
                selected: false,
                type: 'PASSIVE'
            },
            {
                items: [{ xpos: 1, ypos: 5, color: '#454545' }],
                selected: false,
                type: 'PASSIVE'
            }
        ]
    },
    {
        settings: { symType: 'Horizontal' },
        collections: [
            {
                items: [
                    { xpos: 1, ypos: 1, color: '#eeaf61' },
                    { xpos: 1, ypos: 2, color: '#eeaf61' },
                    { xpos: 2, ypos: 1, color: '#eeaf61' }
                ],
                selected: true,
                type: 'ACTIVE'
            },
            {
                items: [
                    { xpos: 2, ypos: 2, color: '#eeaf61' },
                    { xpos: 2, ypos: 3, color: '#eeaf61' }
                ],
                selected: false,
                type: 'ACTIVE'
            },
            {
                items: [
                    { xpos: 1, ypos: 6, color: '#eeaf61' }
                    // { xpos: 2, ypos: 6, color: '#04bae2' }
                ],
                selected: false,
                type: 'ACTIVE'
            },
            {
                items: [{ xpos: 3, ypos: 5, color: '#454545' }],
                selected: false,
                type: 'PASSIVE'
            },
            {
                items: [{ xpos: 3, ypos: 4, color: '#454545' }],
                selected: false,
                type: 'PASSIVE'
            }
        ]
    },
    {
        settings: { symType: 'Horizontal' },
        collections: [
            {
                items: [
                    { xpos: 3, ypos: 1, color: '#eeaf61' },
                    { xpos: 2, ypos: 2, color: '#eeaf61' },
                    { xpos: 3, ypos: 2, color: '#eeaf61' }
                ],
                selected: true,
                type: 'ACTIVE'
            },
            {
                items: [
                    { xpos: 4, ypos: 7, color: '#eeaf61' },
                    { xpos: 5, ypos: 7, color: '#eeaf61' },
                    { xpos: 4, ypos: 8, color: '#eeaf61' }
                ],
                selected: false,
                type: 'ACTIVE'
            },
            {
                items: [
                    { xpos: 1, ypos: 3, color: '#454545' },
                    { xpos: 2, ypos: 3, color: '#454545' }
                ],
                selected: false,
                type: 'PASSIVE'
            },
            {
                items: [
                    { xpos: 4, ypos: 6, color: '#454545' },
                    { xpos: 5, ypos: 6, color: '#454545' }
                ],
                selected: false,
                type: 'PASSIVE'
            }
        ]
    },
    {
        ///level 3
        settings: { symType: 'Vertical' },
        collections: [
            {
                items: [{ xpos: 2, ypos: 1, color: '#eeaf61' }],
                selected: true,
                type: 'ACTIVE'
            },
            {
                items: [
                    { xpos: 4, ypos: 4, color: '#eeaf61' },
                    { xpos: 5, ypos: 4, color: '#eeaf61' }
                ],
                selected: false,
                type: 'ACTIVE'
            },
            {
                items: [
                    { xpos: 0, ypos: 5, color: '#eeaf61' },
                    { xpos: 1, ypos: 5, color: '#eeaf61' },
                    { xpos: 1, ypos: 6, color: '#eeaf61' },
                    { xpos: 0, ypos: 7, color: '#eeaf61' },
                    { xpos: 1, ypos: 7, color: '#eeaf61' }
                ],
                selected: false,
                type: 'ACTIVE'
            },
            {
                items: [
                    { xpos: 1, ypos: 2, color: '#454545' },
                    { xpos: 2, ypos: 2, color: '#454545' },
                    { xpos: 1, ypos: 3, color: '#454545' }
                ],
                selected: false,
                type: 'PASSIVE'
            },
            {
                items: [
                    { xpos: 2, ypos: 6, color: '#454545' },
                    { xpos: 3, ypos: 6, color: '#454545' }
                ],
                selected: false,
                type: 'PASSIVE'
            }
        ]
    },
    {
        /// level 3
        settings: { symType: 'Vertical' },
        collections: [
            {
                items: [{ xpos: 0, ypos: 1, color: '#ef5d5b' }],
                selected: true,
                type: 'ACTIVE'
            },
            {
                items: [
                    { xpos: 2, ypos: 2, color: '#ef5d5b' },
                    { xpos: 1, ypos: 3, color: '#ef5d5b' },
                    { xpos: 2, ypos: 3, color: '#ef5d5b' }
                ],
                selected: true,
                type: 'ACTIVE'
            },
            {
                items: [
                    { xpos: 2, ypos: 6, color: '#ef5d5b' },
                    { xpos: 1, ypos: 7, color: '#ef5d5b' },
                    { xpos: 2, ypos: 7, color: '#ef5d5b' },
                    { xpos: 3, ypos: 7, color: '#ef5d5b' },
                    { xpos: 2, ypos: 8, color: '#ef5d5b' }
                ],
                selected: true,
                type: 'ACTIVE'
            },
            {
                items: [{ xpos: 4, ypos: 6, color: '#ef5d5b' }],
                selected: true,
                type: 'ACTIVE'
            },
            {
                items: [
                    { xpos: 2, ypos: 1, color: '#2b2b2b' },
                    { xpos: 3, ypos: 1, color: '#2b2b2b' },
                    { xpos: 4, ypos: 1, color: '#2b2b2b' },
                    { xpos: 4, ypos: 2, color: '#2b2b2b' }
                ],
                selected: false,
                type: 'PASSIVE'
            },
            {
                items: [
                    { xpos: 1, ypos: 5, color: '#454545' },
                    { xpos: 2, ypos: 5, color: '#454545' },
                    { xpos: 3, ypos: 5, color: '#454545' },
                    { xpos: 1, ypos: 6, color: '#454545' }
                ],
                selected: false,
                type: 'PASSIVE'
            }
        ]
    },
    {
        ///level 3
        settings: { symType: 'Horizontal' },
        collections: [
            {
                items: [
                    { xpos: 2, ypos: 2, color: '#eeaf61' },
                    { xpos: 3, ypos: 2, color: '#eeaf61' },
                    { xpos: 3, ypos: 1, color: '#eeaf61' },
                    { xpos: 4, ypos: 2, color: '#eeaf61' }
                ],
                selected: true,
                type: 'ACTIVE'
            },
            {
                items: [
                    { xpos: 0, ypos: 7, color: '#eeaf61' },
                    { xpos: 1, ypos: 5, color: '#eeaf61' },
                    { xpos: 1, ypos: 6, color: '#eeaf61' },
                    { xpos: 1, ypos: 7, color: '#eeaf61' },
                    { xpos: 1, ypos: 8, color: '#eeaf61' },
                    { xpos: 2, ypos: 7, color: '#ef5d5b' }
                ],
                selected: false,
                type: 'ACTIVE'
            },
            {
                items: [
                    { xpos: 3, ypos: 7, color: '#eeaf61' },
                    { xpos: 4, ypos: 7, color: '#eeaf61' },
                    { xpos: 3, ypos: 8, color: '#eeaf61' },
                    { xpos: 4, ypos: 8, color: '#eeaf61' }
                ],
                selected: false,
                type: 'ACTIVE'
            },
            {
                items: [{ xpos: 3, ypos: 6, color: '#454545' }],
                selected: false,
                type: 'PASSIVE'
            },
            {
                items: [{ xpos: 2, ypos: 6, color: '#454545' }],
                selected: false,
                type: 'PASSIVE'
            }
        ]
    }
];
